export class StringHelper {
  static capitalizeFirstLetter(str: string) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  static toTitleCase(str: string) {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  }
  static removeEverythingInSquareBrackets(inputString: string) {
    return inputString.replace(/\[.*?\]/g, "");
  }
  static removeEverythingButNumbers(inputString: string) {
    return inputString.replace(/[^0-9]/g, "");
  }

  static trimStringToLengthWithElipsis(inputString: string, length: number) {
    if (inputString.length - 3 > length) {
      return inputString.substring(0, length) + "...";
    }
    return inputString;
  }

  static replaceNewLineWithLineBreak(value: string | undefined) {
    return value ? value.replace(/\\n/g, "\n") : "";
  }

  static removeAllSpaces(inputString: string) {
    return inputString.replace(/\s+/g, "");
  }

  static toFullName(firstName: string | null | undefined, lastName: string | null | undefined) {
    if (!firstName && !lastName) {
      return "";
    }
    return [firstName, lastName]
      .filter(Boolean)
      .map((name) => name?.trim())
      .filter(Boolean)
      .join(" ");
  }

  static isString(value: unknown): value is string {
    return typeof value === "string" || value instanceof String;
  }

  static normalizeUnitDimensions(dimensions: string): string {
    return dimensions.replace(/\s*x\s*/i, "x");
  }
}
